export default {"src":"/_next/static/media/Brownie.f75d6c41.svg","height":32,"width":32};